import { Injectable } from '@angular/core';

import { HttpDataService } from '../../../../shared/http/http-data.service';
import { IDocument } from '../../../../../type_definitions/datatypes';
import { AuthService } from '../../../../shared/services/auth/auth.service';

export interface IDocumentType {
  code?:string;
  description?:string;
}

export interface IDocumentInfo {
  caveatsDocumentsCount?:{ count:number; };
  missingDocumentTypes?:IDocumentType[];
  bpProfileDocuments?:IDocument[];
}

@Injectable()
export class BPProfilesDocumentsDataService {
  constructor(
    private httpDataService:HttpDataService,
    private authService:AuthService
  ) {
    /**/
  }

  private getBaseDocumentUrl(profileId:number):string {
    return `rest/bpprofiles/profiles/${profileId}/documents`;
  }

  public getAuthenticatedBaseDocumentUrl(profileId:number):string {
    return this.authService.authenticatedUrl(this.getBaseDocumentUrl(profileId));
  }

  public getAuthenticatedDocumentUrl(profileId:number, attachmentId:number):string {
    return this.authService.authenticatedUrl(`${this.getBaseDocumentUrl(profileId)}/${attachmentId}`);
  }

  public getDocumentsInfo(profileId:number):Promise<IDocumentInfo> {
    return this.httpDataService.doGET(
      `${this.getBaseDocumentUrl(profileId)}/info`,
      undefined,
      undefined,
      'Error getting documents info'
    );
  }

  public updateDocument(profileId:number, data:IDocument):Promise<IDocument> {
    return this.httpDataService.doPUT(
      `${this.getBaseDocumentUrl(profileId)}/${data?.id}`,
      undefined,
      data,
      undefined,
      'Error updating document'
    );
  }

  public deleteDocument(profileId:number, attachmentId:number):Promise<void> {
    return this.httpDataService.doDELETE(
      `${this.getBaseDocumentUrl(profileId)}/${attachmentId}`,
      undefined,
      undefined,
      'Error deleting document'
    );
  }
}